import React from 'react';

export default function SessionExpiryModal({ secondsLeft, onStay, onLogout }) {
  const pct = Math.max(0, Math.min(100, (secondsLeft / 60) * 100));
  const urgent = secondsLeft <= 15;

  return (
    <div className="session-modal-overlay">
      <div className={`session-modal${urgent ? ' session-urgent' : ''}`}>
        <div className="session-ring-wrap">
          <svg className="session-ring" viewBox="0 0 80 80">
            <circle cx="40" cy="40" r="34" fill="none" stroke="#e0dce8" strokeWidth="5" />
            <circle cx="40" cy="40" r="34" fill="none" stroke={urgent ? '#e74c3c' : '#c9a227'}
              strokeWidth="5" strokeLinecap="round" strokeDasharray={`${pct * 2.136} 213.6`}
              transform="rotate(-90 40 40)" className="session-ring-arc" />
          </svg>
          <div className={`session-timer${urgent ? ' session-timer-urgent' : ''}`}>{secondsLeft}</div>
        </div>
        <h3>Session Expiring</h3>
        <p>You'll be signed out due to inactivity</p>
        <div className="session-modal-actions">
          <button className="btn btn-primary session-btn-stay" onClick={onStay}>Stay Signed In</button>
          <button className="btn btn-secondary" onClick={onLogout}>Log Out</button>
        </div>
      </div>
    </div>
  );
}
